interface HeroLink {
  title: string;
  iconUrl: string;
  url: string;
}

export default function HeroLinks({
  heroLinks = [],
}: {
  heroLinks: HeroLink[];
}) {
  return (
    <nav className="hero-links">
      <ul>
        {heroLinks.map(({ title, url, iconUrl }, idx) => {
          const external = !!url?.match(/^https?:/);
          return (
            <li key={idx}>
              <a
                href={url}
                target={external ? "_blank" : undefined}
                rel={external ? "noreferrer" : undefined}
              >
                {title}
                <img src={iconUrl} alt="" />
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
